module.exports = __webpack_public_path__ + "img/desc.0afd97a7.png";